import NoteCard from '../NoteCard/NoteCard'
import TopicDrawerEmpty from '../TopicDrawerEmpty/TopicDrawerEmpty'
import TopicDrawerSkeleton from '../TopicDrawerSkeleton/TopicDrawerSkeleton'
import * as Styles from './styles'

const TopicDrawerBody = ({ data, loading }) => {
  if (loading || !data) {
    return <TopicDrawerSkeleton />
  }

  if (!data.results?.length) {
    return <TopicDrawerEmpty />
  }

  return (
    <Styles.Container>
      <Styles.NoteList>
        {data.results.map((note, index) => (
          <NoteCard key={`${note.return_id}-${index}`} note={note} />
        ))}
      </Styles.NoteList>
    </Styles.Container>
  )
}

export default TopicDrawerBody
